import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { format, getDate } from 'date-fns';
import Button from './Button';

function CalendarDay({
	className,
	closed,
	date,
	open,
	past,
	today,
	invalid,
	selected,
	notInCurrentMonth,
	onDateClick,
}) {
	const handleClick = () => {
		onDateClick({
			date,
			string: format(date, 'MM/dd/yyyy'),
		});
	};

	const type = {
		past,
		today,
		open,
		closed,
		invalid,
		selected,
	};

	const isDisabled = past || closed || invalid;

	return (
		<td>
			<Button
				className={classnames('calendar-day', type, className, {
					'next-month': notInCurrentMonth,
				})}
				onClick={handleClick}
				disabled={isDisabled}
			>
				<div className="date-text">
					<div className="date-number-text">{getDate(date)}</div>
					{closed && <div className="state-text">Closed</div>}
					{today && !closed && <div className="state-text">Today</div>}
				</div>
			</Button>
		</td>
	);
}

CalendarDay.propTypes = {
	date: PropTypes.instanceOf(Date).isRequired,
	closed: PropTypes.bool,
	open: PropTypes.bool,
	past: PropTypes.bool,
	today: PropTypes.bool,
	invalid: PropTypes.bool,
	selected: PropTypes.bool,
	notInCurrentMonth: PropTypes.bool,
	onDateClick: PropTypes.func.isRequired,
	className: PropTypes.string,
};

export default CalendarDay;
